<template>
    <div class="titulo">
        <div class="margem container">
            <div class="m-icone direita">
                <button class="acao-secundaria">
                    <a v-if="!loading && !needConnectGoogle && !erro" :href="urlGoogleEventEdit" target="_blank"
                        class="btn btn-primary">
                        Adicionar Evento
                    </a>
                </button>
            </div>
            <h2>Suas Reuniões</h2>

        </div>
    </div>
    <div class="margem container">
        <div v-if="!loading && !needConnectGoogle && !erro">
            <div class="label-semana-wrapper">
                <h3>{{ labelSemanaExibida }}</h3>
                <button v-if="!estaNaSemanaAtual" type="button" class="btn-hoje" aria-label="Voltar ao dia de hoje"
                    @click="irParaHoje">
                    <i class="bi bi-calendar-day"></i>
                    Hoje
                </button>
            </div>
            <div class="abas-nav">
                <button type="button" class="btn-setas" aria-label="Semana anterior" @click="semanaAnterior">
                    <i class="bi bi-chevron-left"></i>
                </button>
                <div class="abas">
                    <a v-for="dia in diasParaAbas" :key="dia.date" href="#"
                        :class="{ ativo: diaSelecionado === dia.date, 'dia-hoje': dia.isHoje }"
                        @click.prevent="diaSelecionado = dia.date">
                        <span v-if="dia.isHoje" class="badge-hoje">Hoje</span>
                        {{ dia.label }}
                        <span class="badge-eventos">{{ dia.count }}</span>
                    </a>
                </div>
                <button type="button" class="btn-setas" aria-label="Próxima semana" @click="semanaProxima">
                    <i class="bi bi-chevron-right"></i>
                </button>
            </div>
        </div>
        <div class="bloco margem">
            <p v-if="mensagemSucesso" class="mensagem-sucesso">{{ mensagemSucesso }}</p>

            <div v-if="loading" class="loading">
                <div></div>
            </div>

            <div v-else-if="needConnectGoogle" class="conectar-google">
                <p>Conecte sua conta Google para listar suas reuniões e eventos do Google Agenda.</p>
                <button type="button" class="btn btn-primary" @click="conectarGoogle">Conectar conta Google</button>
            </div>

            <div v-else-if="erro" class="erro">
                <p>{{ erro }}</p>
                <button type="button" class="btn btn-secondary" @click="carregarReunioes">Tentar novamente</button>
            </div>

            <div v-else ref="blocoListaReunioes">
                <input type="file" ref="fileInput" @change="adicionarAnexo" multiple style="display: none" />
                <div v-if="mensagemReuniaoNaoNaAgenda" class="mensagem-reuniao-nao-agenda">
                    <span>{{ mensagemReuniaoNaoNaAgenda }}</span>
                    <button type="button" class="mensagem-reuniao-fechar" aria-label="Fechar"
                        @click="mensagemReuniaoNaoNaAgenda = null">
                        <i class="bi bi-x-lg"></i>
                    </button>
                </div>
                <ul v-if="reunioesDoDia.length" class="lista-reunioes">
                    <li v-for="r in reunioesDoDia" :key="r.id" class="item-reuniao"
                        :class="{ 'status-cancelado': r.status === 'cancelled', 'reuniao-em-foco': reuniaoEmFocoId === r.id }"
                        :data-reuniao-id="r.id">
                        <div class="reuniao-cabecalho">
                            <div class="reuniao-titulo">{{ r.summary || '(Sem título)' }}</div>
                            <!-- <span v-if="r.status" class="chip" :class="corStatus(r.status)">{{ labelStatus(r.status) }}</span> -->
                            <div class="reuniao-acoes">
                                <a v-if="r.hangoutLink" :href="r.hangoutLink" target="_blank" class="chip bg-ok">Abrir
                                    no Meet</a>
                                <a v-if="r.htmlLink" :href="r.htmlLink" target="_blank" class="chip bg-cinza">Ver na
                                    Agenda</a>
                            </div>
                        </div>
                        <div class="reuniao-horario">
                            <i class="bi-clock-fill ico-horario"></i>
                            {{ textoHorarioReuniao(r) }}
                        </div>
                        <div v-if="r.location" class="reuniao-info">
                            <i class="bi bi-geo-alt-fill ico-local"></i>
                            {{ r.location }}
                        </div>
                        <div v-if="r.description" class="reuniao-descricao" v-html="descricaoComoHtml(r.description)">
                        </div>
                        <div v-if="participantesLista(r).length" class="reuniao-participantes">
                            <div class="participantes-titulo">Participantes</div>
                            <div class="participantes-lista">
                                <div v-for="(p, i) in participantesLista(r)" :key="p.email || i" class="participante"
                                    :class="{ organizador: p.organizer }">
                                    <span class="nome">{{ p.displayName || p.email }}</span>
                                    <span v-if="p.organizer" class="chip bg-sucesso">Organizador(a)</span>
                                    <span v-else-if="p.responseStatus" class="chip"
                                        :class="corResposta(p.responseStatus)">{{ labelResposta(p.responseStatus)
                                        }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="reuniao-participantes">
                            <div class="participantes-titulo">Anexos <i class="bi-plus-circle"
                                    @click="abrirFileInput(r)" :title="'Adicionar anexo'"></i></div>
                            <div v-if="anexosGoogle(r).length" class="anexos-google">
                                <a v-for="(a, i) in anexosGoogle(r)" :key="a.fileId || a.fileUrl || i"
                                    :href="a.fileUrl" target="_blank"  class="anexo-google"
                                    :class="'tipo-' + (a.tipo || 'outro')" :title="a.title">
                                    <i :class="iconeAnexoGoogle(a)"></i>
                                    <span class="anexo-google-label">{{ labelAnexoGoogle(a) }}</span>
                                </a>
                            </div>
                            <div class="participantes-lista">
                                <div v-for="(a) in r.anexos" :key="a.id" class="anexo margem">
                                    <a :href="a.caminho" target="_blank" class="nome">{{ a.nome_original }}</a>
                                    <i class="bi bi-trash-fill" @click="excluirAnexo(r, a)" :title="'Excluir anexo'"
                                        style="cursor: pointer; font-size: 14px;"></i>
                                </div>
                            </div>
                        </div>
                        <div class="reuniao-tarefas">
                            <div class="participantes-titulo">Tarefas desta reunião</div>
                            <table class="tabela tabela-tarefas-reuniao">
                                <tbody>
                                    <tr>
                                        <th>Código</th>
                                        <th>Descrição</th>
                                        <th>Responsável</th>
                                        <th>Início prev.</th>
                                        <th>Fim prev.</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                    <tr v-for="t in (r.tarefas || [])" :key="t.id" class="linha-tarefa"
                                        :class="{ 'tarefa-em-foco': destaqueTarefaId && String(t.id) === String(destaqueTarefaId) }">
                                        <td @click="abrirModalEditarTarefa(r, t)" class="clicavel"><span class="codigo-tarefa">{{ t.codigo || '–' }}</span></td>
                                        <td class="descricao-tarefa clicavel" :title="t.descricao || t.titulo"
                                            @click="abrirModalEditarTarefa(r, t)">
                                            <div class="descTarefa">
                                                {{ t.descricao ||
                                                    t.titulo || '–' }}
                                            </div>
                                        </td>
                                        <td @click="abrirModalEditarTarefa(r, t)" class="clicavel">{{ t.responsavel?.name || '–' }}</td>
                                        <td>
                                            <input type="date" :value="t.dt_inicio || ''"
                                                @change="atualizarDataTarefa(r, t.id, 'dt_inicio', $event.target.value)" />
                                        </td>
                                        <td>
                                            <input type="date" :value="t.dt_fim || ''"
                                                @change="atualizarDataTarefa(r, t.id, 'dt_fim', $event.target.value)" />
                                        </td>
                                        <td>
                                            <BarraProgresso :prop-item="getItemBarra(t)" :id-usuario="idUsuario"
                                                :is-coordenador="true"
                                                @editarStatus="(id, payload) => atualizarStatusTarefaBarra(r, id, payload)" />
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td colspan="6">
                                            <div class="alinha-v inputNovaTarefa">
                                                <strong>
                                                    {{ proximoCodigoTarefa(r) }}
                                                </strong>
                                                <input v-model="getNovo(r).descricao" type="text"
                                                    placeholder="Descrição da nova tarefa"
                                                    @keydown.enter.prevent="adicionarTarefa(r)" />
                                                <select v-model.number="getNovo(r).responsavel_id">
                                                    <option value="" hidden>Responsável pela tarefa</option>
                                                    <optgroup v-if="(r.participantes_thalamus || []).length"
                                                        label="Participantes da reunião">
                                                        <option v-for="pt in (r.participantes_thalamus || [])"
                                                            :key="pt.user_id" :value="pt.user_id">
                                                            {{ pt.name || pt.email }}
                                                        </option>
                                                    </optgroup>
                                                    <optgroup label="Outros">
                                                        <option v-for="u in outrosResponsaveis(r)" :key="u.id"
                                                            :value="u.id">
                                                            {{ u.name || u.email }}
                                                        </option>
                                                    </optgroup>
                                                </select>
                                                <input type="date" v-model="getNovo(r).dt_fim" title="Fim previsto" />
                                                <button type="button" class="btn btn-sm btn-primary"
                                                    :disabled="!getNovo(r).descricao || !getNovo(r).responsavel_id || !getNovo(r).dt_fim"
                                                    @click="adicionarTarefa(r)">
                                                    Adicionar
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </li>
                </ul>
                <p v-else class="sem-reunioes">Nenhuma reunião neste dia.</p>
            </div>
        </div>
    </div>
    <ModalEditarTarefaReuniao v-if="showModalTarefa && tarefaEditada && reuniaoDaTarefaEditada"
        :prop-tarefa="tarefaEditada" :prop-reuniao-id="reuniaoDaTarefaEditada.id" :usuarios="usuariosParaModalReuniao"
        :id-usuario="idUsuario"
        @fecharModal="showModalTarefa = false; reuniaoDaTarefaEditada = null; tarefaEditada = null; carregarReunioes()" />

</template>

<script>
import { api } from "roboflex-thalamus-request-handler";
import { sso } from "roboflex-thalamus-sso-lib";
import BarraProgresso from '@/components/BarraProgresso.vue';
import ModalEditarTarefaReuniao from '@/components/Modais/reunioes/ModalEditarTarefaReuniao.vue';

export default {
    name: 'ListaReunioes',
    components: { BarraProgresso, ModalEditarTarefaReuniao },
    data() {
        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        const hojeStr = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}-${String(hoje.getDate()).padStart(2, '0')}`;
        return {
            reunioes: [],
            diaSelecionado: hojeStr,
            semanaAtualOffset: 0,
            loading: true,
            erro: null,
            needConnectGoogle: false,
            mensagemSucesso: null,
            erroOAuthFromCallback: false,
            usuarios: [],
            novoPorReuniao: {},
            pollingReunioes: null,
            idUsuario: null,
            urlGoogleEventEdit: 'https://calendar.google.com/calendar/u/0/r/eventedit',
            mensagemReuniaoNaoNaAgenda: null,
            reuniaoEmFocoId: null,
            destaqueTarefaId: null,
            showModalTarefa: false,
            tarefaEditada: null,
            reuniaoDaTarefaEditada: null,
        };
    },
    created() {
        const usuarioLogado = sso.getUsuarioLogado();
        this.idUsuario = usuarioLogado?.id ?? null;
    },
    mounted() {
        const query = this.$route?.query?.google;
        if (query === 'connected') {
            this.mensagemSucesso = 'Conta Google conectada.';
            setTimeout(() => { this.mensagemSucesso = null; }, 4000);
        } else if (query && String(query).startsWith('error=')) {
            this.erroOAuthFromCallback = true;
            const code = String(query).replace('error=', '');
            const mensagens = {
                exchange_failed: 'Não foi possível concluir a conexão com o Google. Verifique se a URL de redirecionamento no Google Cloud está igual à do backend e tente novamente.',
                redirect_uri_mismatch: 'A URL de redirecionamento não confere. No Google Cloud Console, a URI deve ser exatamente a mesma que o backend usa (ex.: http://localhost.thalamus.ind.br:8000/api/google/calendar/callback).',
                save_failed: 'Não foi possível salvar a permissão do Google. Tente atualizar de novo.',
                sem_empresa: 'Seu usuário não está vinculado a uma empresa, então a conta Google não pode ser conectada.',
            };
            this.erro = mensagens[code] || `Erro ao conectar: ${code}. Tente novamente.`;
            this.needConnectGoogle = true;
        }
        this.carregarReunioes();
        this.carregarUsuarios();
        this.iniciarPollingReunioes();
    },
    beforeUnmount() {
        if (this.pollingReunioes) {
            clearInterval(this.pollingReunioes);
        }
    },
    computed: {
        domingoAtual() {
            return this.getDomingo(new Date());
        },
        inicioSemanaExibida() {
            const s = new Date(this.domingoAtual);
            s.setDate(s.getDate() + 7 * this.semanaAtualOffset);
            return s;
        },
        diasParaAbas() {
            const diasShort = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);
            const lista = [];
            let d = new Date(this.inicioSemanaExibida);
            for (let i = 0; i < 7; i++) {
                const y = d.getFullYear();
                const m = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const dateStr = `${y}-${m}-${day}`;
                const isHoje = d.getFullYear() === hoje.getFullYear() && d.getMonth() === hoje.getMonth() && d.getDate() === hoje.getDate();
                const label = `${diasShort[d.getDay()]} ${day}/${m}`;
                const count = this.reunioes.filter((r) => this.dataLocalStr(r.start) === dateStr).length;
                lista.push({ date: dateStr, label, isHoje, count });
                d.setDate(d.getDate() + 1);
            }
            return lista;
        },
        estaNaSemanaAtual() {
            return this.semanaAtualOffset === 0;
        },
        labelSemanaExibida() {
            const inicio = this.inicioSemanaExibida;
            const fim = new Date(inicio);
            fim.setDate(inicio.getDate() + 6);
            const diaInicio = String(inicio.getDate()).padStart(2, '0');
            const diaFim = String(fim.getDate()).padStart(2, '0');
            const mesInicio = inicio.toLocaleDateString('pt-BR', { month: 'long' });
            const mesFim = fim.toLocaleDateString('pt-BR', { month: 'long' });
            const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);
            const anoInicio = inicio.getFullYear();
            const anoFim = fim.getFullYear();
            const sufixoAno = anoInicio !== anoFim ? ` de ${anoFim}` : '';
            if (inicio.getMonth() === fim.getMonth() && anoInicio === anoFim) {
                return `${diaInicio} - ${diaFim} de ${cap(mesInicio)}`;
            }
            return `${diaInicio} de ${cap(mesInicio)} - ${diaFim} de ${cap(mesFim)}${sufixoAno}`;
        },
        reunioesDoDia() {
            return this.reunioes.filter((r) => this.dataLocalStr(r.start) === this.diaSelecionado);
        },
        usuariosParaModalReuniao() {
            if (!this.reuniaoDaTarefaEditada) return this.usuarios;
            const participantes = (this.reuniaoDaTarefaEditada.participantes_thalamus || []).map((p) => ({
                id: p.user_id,
                name: p.name,
                email: p.email,
            }));
            const idsParticipantes = new Set(participantes.map((p) => p.id));
            const outros = this.usuarios.filter((u) => !idsParticipantes.has(u.id));
            return [...participantes, ...outros];
        },
    },
    methods: {
        abrirFileInput(reuniao) {
            this.reuniaoEmFocoId = reuniao.id;
            this.$nextTick(() => {
                const input = this.$refs.fileInput;
                if (input && typeof input.click === 'function') {
                    input.click();
                }
            });
        },
        async adicionarAnexo(event) {
            const fileInput = event.target;
            if (fileInput && fileInput.files.length > 0) {
                try {

                    const formData = new FormData();
                    formData.append('arquivo', fileInput.files[0]);
                    await api.post(`/anexar/reuniao/${this.reuniaoEmFocoId}`, formData);
                    fileInput.value = '';
                    await this.carregarReunioes();
                } catch (error) {
                    console.error(error);
                }
            }
        },
        async excluirAnexo(reuniao, anexo) {
            try {
                await api.delete(`/anexos/reuniao/${reuniao.id}/${anexo.id}`);
                await this.carregarReunioes();
            } catch (error) {
                console.error(error);
            }
        },
        parseDateStr(str) {
            if (!str || !/^\d{4}-\d{2}-\d{2}$/.test(str)) return null;
            const d = new Date(str + 'T12:00:00');
            return isNaN(d.getTime()) ? null : d;
        },
        getDomingo(date) {
            const d = new Date(date);
            d.setHours(0, 0, 0, 0);
            d.setDate(d.getDate() - d.getDay());
            return d;
        },
        getSegundaFeira(date) {
            const d = new Date(date);
            d.setHours(0, 0, 0, 0);
            const day = d.getDay();
            const diff = day === 0 ? 1 : day === 6 ? 2 : -(day - 1);
            d.setDate(d.getDate() + diff);
            return d;
        },
        semanaAnterior() {
            const indiceDia = this.indiceDiaSelecionado();
            this.semanaAtualOffset -= 1;
            this.ajustarDiaSelecionadoParaSemana(indiceDia);
        },
        semanaProxima() {
            const indiceDia = this.indiceDiaSelecionado();
            this.semanaAtualOffset += 1;
            this.ajustarDiaSelecionadoParaSemana(indiceDia);
        },
        irParaHoje() {
            this.semanaAtualOffset = 0;
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);
            this.diaSelecionado = this.dateToStr(hoje);
        },
        indiceDiaSelecionado() {
            const d = this.parseDateStr(this.diaSelecionado);
            return d ? d.getDay() : 0;
        },
        ajustarDiaSelecionadoParaSemana(indiceDia = 0) {
            const d = new Date(this.inicioSemanaExibida);
            d.setDate(d.getDate() + Math.min(Math.max(indiceDia, 0), 6));
            this.diaSelecionado = this.dateToStr(d);
        },
        dateToStr(d) {
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        },
        aplicarFocoReuniaoFromQuery() {
            const reuniaoId = this.$route?.query?.reuniao_id;
            const tarefaId = this.$route?.query?.destaque_tarefa_id;
            this.mensagemReuniaoNaoNaAgenda = null;
            this.reuniaoEmFocoId = null;
            this.destaqueTarefaId = null;
            if (!reuniaoId) return;
            const reuniao = this.reunioes.find((r) => String(r.id) === String(reuniaoId));
            if (!reuniao) {
                this.mensagemReuniaoNaoNaAgenda = 'Esta reunião não está na sua agenda.';
                return;
            }
            const dataReuniao = this.dataLocalStr(reuniao.start);
            this.diaSelecionado = dataReuniao;
            const dom = this.getDomingo(this.parseDateStr(dataReuniao));
            const domHoje = this.domingoAtual;
            this.semanaAtualOffset = Math.round((dom.getTime() - domHoje.getTime()) / (7 * 24 * 60 * 60 * 1000));
            this.reuniaoEmFocoId = reuniao.id;
            if (tarefaId) this.destaqueTarefaId = String(tarefaId);
            this.$nextTick(() => {
                const root = this.$refs.blocoListaReunioes;
                const el = root && typeof root.querySelector === 'function'
                    ? root.querySelector(`[data-reuniao-id="${reuniao.id}"]`)
                    : document.querySelector(`[data-reuniao-id="${reuniao.id}"]`);
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            });
        },
        anteriorDiaUtil(d) {
            const out = new Date(d);
            out.setDate(out.getDate() - 1);
            while (out.getDay() === 0 || out.getDay() === 6) out.setDate(out.getDate() - 1);
            return out;
        },
        proximoDiaUtil(d) {
            const out = new Date(d);
            out.setDate(out.getDate() + 1);
            while (out.getDay() === 0 || out.getDay() === 6) out.setDate(out.getDate() + 1);
            return out;
        },
        isDateOnly(val) {
            return typeof val === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val);
        },
        parseCalendarDate(val) {
            if (!val) return null;
            const d = this.isDateOnly(val) ? new Date(`${val}T12:00:00`) : new Date(val);
            return isNaN(d.getTime()) ? null : d;
        },
        textoHorarioReuniao(r) {
            if (this.isDateOnly(r?.start)) {
                return `${this.formatarDataRelativa(r.start)}, Dia inteiro`;
            }
            return `${this.formatarDataRelativa(r?.start)}, ${this.formatarHora(r?.start)} – ${this.formatarHora(r?.end)}`;
        },
        dataLocalStr(isoOrDateStr) {
            if (!isoOrDateStr) return '';
            const d = this.parseCalendarDate(isoOrDateStr);
            if (!d) return '';
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        },
        iniciarPollingReunioes() {
            if (this.pollingReunioes) return;
            this.pollingReunioes = setInterval(() => {
                if (this.loading || this.erro || this.needConnectGoogle) return;
                this.carregarReunioes(true);
            }, 60000);
        },
        async carregarReunioes(silent = false) {
            if (!silent) {
                this.loading = true;
                if (!this.erroOAuthFromCallback) {
                    this.erro = null;
                    this.needConnectGoogle = false;
                }
            }
            try {
                const { data } = await api.get('google/calendar/reunioes');
                this.reunioes = (data.events || []).map((e) => ({ ...e, tarefas: e.tarefas || [] }));
                this.reunioes.forEach((r) => {
                    if (!this.novoPorReuniao[r.id]) {
                        this.novoPorReuniao[r.id] = { descricao: '', responsavel_id: '' };
                    }
                });
                this.novoPorReuniao = { ...this.novoPorReuniao };
                this.$nextTick(() => this.aplicarFocoReuniaoFromQuery());
            } catch (e) {
                if (!silent) {
                    const status = e.response?.status;
                    const code = e.response?.data?.code;
                    if (status === 403 && code === 'google_not_connected') {
                        this.needConnectGoogle = true;
                    } else {
                        this.erro = e.response?.data?.message || 'Erro ao carregar reuniões. Tente novamente.';
                    }
                }
            } finally {
                if (!silent) this.loading = false;
            }
        },
        async conectarGoogle() {
            this.erroOAuthFromCallback = false;
            this.erro = null;
            try {
                const { data } = await api.get('google/calendar/redirect-url');
                if (data.redirect_url) {
                    window.location = data.redirect_url;
                }
            } catch (e) {
                this.erro = e.response?.data?.message || 'Erro ao obter link de conexão.';
            }
        },
        formatarDataRelativa(val) {
            if (!val) return '–';
            const d = this.parseCalendarDate(val);
            if (!d) return '–';
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);
            const data = new Date(d.getFullYear(), d.getMonth(), d.getDate());
            const diff = Math.floor((data - hoje) / (1000 * 60 * 60 * 24));
            const dias = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
            if (diff === 0) return 'Hoje';
            if (diff === 1) return 'Amanhã';
            if (diff === -1) return 'Ontem';
            if (diff >= -7 && diff <= -2) return `Última ${dias[d.getDay()].toLowerCase()}`;
            if (diff >= 2 && diff <= 7) return `Próxima ${dias[d.getDay()].toLowerCase()}`;
            return d.toLocaleDateString('pt-BR', { day: 'numeric', month: 'short', year: d.getFullYear() !== hoje.getFullYear() ? 'numeric' : undefined });
        },
        formatarHora(val) {
            if (!val) return '–';
            if (this.isDateOnly(val)) return 'Dia inteiro';
            const d = new Date(val);
            if (isNaN(d.getTime())) return '–';
            return d.toLocaleTimeString('pt-BR', {
                hour: '2-digit',
                minute: '2-digit',
            });
        },
        formatarDataShort(val) {
            if (!val) return '–';
            const d = typeof val === 'string' && val.length === 10 ? new Date(val + 'T12:00:00') : new Date(val);
            if (isNaN(d.getTime())) return '–';
            return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
        },
        formatarDataHora(val) {
            if (!val) return '–';
            const d = new Date(val);
            if (isNaN(d.getTime())) return '–';
            return d.toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            });
        },
        statusApiParaBarra(status) {
            const map = { pendente: 'Pendente', em_andamento: 'Em andamento', concluida: 'Concluído', cancelada: 'Cancelada' };
            return map[status] ?? status ?? 'Pendente';
        },
        statusBarraParaApi(status) {
            return status ?? 'Pendente';
        },
        getItemBarra(t) {
            if (!t) return null;
            return {
                id: t.id,
                status: this.statusApiParaBarra(t.status),
                responsavel_id: t.responsavel_id,
            };
        },
        async atualizarStatusTarefaBarra(r, tarefaId, payload) {
            const statusEnvio = this.statusBarraParaApi(payload.status);
            try {
                const { data } = await api.patch(`google/calendar/reunioes/${r.id}/tarefas/${tarefaId}`, { status: statusEnvio });
                const idx = (r.tarefas || []).findIndex((x) => x.id === tarefaId);
                if (idx !== -1 && data.tarefa) {
                    r.tarefas[idx] = data.tarefa;
                }
            } catch (e) {
                this.erro = e.response?.data?.message || 'Erro ao atualizar status.';
            }
        },
        /** Sanitiza HTML da descrição (Google envia <b>, <br>, etc.) — permite só tags seguras. */
        descricaoComoHtml(html) {
            if (!html || typeof html !== 'string') return '';
            const allowed = ['b', 'i', 'br', 'p', 'strong', 'em'];
            const div = document.createElement('div');
            div.innerHTML = html;
            const toReplace = Array.from(div.querySelectorAll('*')).filter(
                (el) => !allowed.includes(el.tagName.toLowerCase())
            );
            toReplace.forEach((el) => {
                const text = document.createTextNode(el.textContent || '');
                el.parentNode.replaceChild(text, el);
            });
            return div.innerHTML;
        },
        labelStatus(status) {
            const map = { confirmed: 'Confirmado', tentative: 'Talvez', cancelled: 'Cancelado' };
            return map[status] || status;
        },
        corStatus(status) {
            const map = { confirmed: 'bg-sucesso', tentative: 'bg-alerta', cancelled: 'bg-erro' };
            return map[status] || 'bg-cinza';
        },
        corResposta(responseStatus) {
            const map = { needsAction: 'bg-cinza', declined: 'bg-erro', tentative: 'bg-ok', accepted: 'bg-sucesso' };
            return map[responseStatus] || 'bg-cinza';
        },
        labelResposta(responseStatus) {
            const map = { needsAction: 'Pendente', declined: 'Recusou', tentative: 'Talvez', accepted: 'Aceito' };
            return map[responseStatus] || responseStatus;
        },
        participantesLista(r) {
            const list = [];
            const emailsVistos = new Set();
            if (r.organizer) {
                list.push({
                    email: r.organizer.email,
                    displayName: r.organizer.displayName,
                    organizer: true,
                });
                if (r.organizer.email) emailsVistos.add(r.organizer.email.toLowerCase());
            }
            (r.attendees || []).forEach((att) => {
                const key = (att.email || '').toLowerCase();
                if (key && emailsVistos.has(key)) return;
                if (key) emailsVistos.add(key);
                list.push({
                    email: att.email,
                    displayName: att.displayName,
                    responseStatus: att.responseStatus,
                    organizer: att.organizer,
                });
            });
            return list;
        },
        anexosGoogle(r) {
            return (r.attachments || []).filter((a) => a && a.fileUrl);
        },
        labelAnexoGoogle(a) {
            if (a.tipo === 'gravacao') return 'Gravação';
            if (a.tipo === 'transcricao') return 'Transcrição';
            return a.title || 'Anexo do Google';
        },
        iconeAnexoGoogle(a) {
            if (a.tipo === 'gravacao') return 'bi bi-camera-video-fill';
            if (a.tipo === 'transcricao') return 'bi bi-file-earmark-text-fill';
            return 'bi bi-file-earmark-fill';
        },
        participanteThalamus(r, p) {
            const list = r.participantes_thalamus || [];
            const email = (p.email || '').toLowerCase();
            return list.find((pt) => (pt.email || '').toLowerCase() === email) || null;
        },
        async carregarUsuarios() {
            try {
                const { data } = await api.get('google/calendar/usuarios');
                this.usuarios = data.usuarios || [];
            } catch (_) {
                this.usuarios = [];
            }
        },
        getNovo(r) {
            if (!this.novoPorReuniao[r.id]) {
                this.novoPorReuniao[r.id] = { descricao: '', responsavel_id: '', dt_fim: '' };
                this.novoPorReuniao = { ...this.novoPorReuniao };
            }
            return this.novoPorReuniao[r.id];
        },
        outrosResponsaveis(r) {
            const idsParticipantes = new Set((r.participantes_thalamus || []).map((p) => p.user_id));
            return this.usuarios.filter((u) => !idsParticipantes.has(u.id));
        },
        proximoCodigoTarefa(r) {
            const n = (r.tarefas || []).length + 1;
            return `Tarefa - ${n}`;
        },
        labelStatusTarefa(status) {
            const map = { pendente: 'A iniciar', em_andamento: 'Em andamento', concluida: 'Concluído', cancelada: 'Cancelada' };
            return map[status] ?? status ?? 'A iniciar';
        },
        classeCorStatus(status) {
            if (status === 'cancelada') return 'status-cancelada';
            if (status === 'concluida') return 'status-concluida';
            if (status === 'em_andamento' || (typeof status === 'string' && status.startsWith('Em andamento'))) return 'status-andamento';
            return 'status-pendente';
        },
        async atualizarDataTarefa(r, tarefaId, campo, valor) {
            const payload = { [campo]: valor || null };
            try {
                const { data } = await api.patch(`google/calendar/reunioes/${r.id}/tarefas/${tarefaId}`, payload);
                const idx = (r.tarefas || []).findIndex((x) => x.id === tarefaId);
                if (idx !== -1 && data.tarefa) {
                    r.tarefas[idx] = data.tarefa;
                }
            } catch (e) {
                this.erro = e.response?.data?.message || 'Erro ao atualizar data.';
            }
        },
        abrirModalEditarTarefa(reuniao, tarefa) {
            this.reuniaoDaTarefaEditada = reuniao;
            this.tarefaEditada = tarefa;
            this.showModalTarefa = true;
        },
        async adicionarTarefa(r) {
            const novo = this.novoPorReuniao[r.id];
            if (!novo || !novo.descricao || !novo.responsavel_id || !novo.dt_fim) return;
            try {
                const { data } = await api.post(`google/calendar/reunioes/${r.id}/tarefas`, {
                    descricao: novo.descricao,
                    responsavel_id: novo.responsavel_id,
                    dt_fim: novo.dt_fim,
                });
                const reuniao = this.reunioes.find((x) => x.id === r.id);
                if (reuniao) {
                    if (!reuniao.tarefas) reuniao.tarefas = [];
                    reuniao.tarefas.push(data.tarefa);
                }
                this.novoPorReuniao[r.id] = { descricao: '', responsavel_id: '', dt_fim: '' };
                this.novoPorReuniao = { ...this.novoPorReuniao };
            } catch (e) {
                this.erro = e.response?.data?.message || 'Erro ao criar tarefa.';
            }
        },
    },
};
</script>

<style scoped>
.bi-plus-circle {
    font-size: 16px;
    cursor: pointer;
    color: var(--cor-fonte);
}

.bi-plus-circle:hover {
    color: var(--cor-sucesso);
    transform: scale(1.2);
    transition: transform 0.3s ease;
}
.bi-trash-fill {
    font-size: 14px;
    cursor: pointer;
    color: var(--cor-fonte-fraca);
}

.bi-trash-fill:hover {
        color: var(--cor-erro);
        transform: scale(1.2);
        transition: transform 0.3s ease;
    }

.descricao-tarefa {
    max-width: 14rem;
    width: 14rem;
    vertical-align: top;
}

.descTarefa {
    max-width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    overflow-wrap: break-word;
}

.inputNovaTarefa {
    gap: 0.5rem;

    strong {
        border: 1px solid var(--cor-separador);
        border-radius: 5px;
        padding: 0.3rem;
        width: fit-content;
        white-space: nowrap;
        padding: 0 .5rem;
        text-align: center;
        align-content: center;
        height: 3rem;
    }

    select {
        width: fit-content;
    }

    input {
        height: 3rem;
        margin: 0;
        margin-left: 5px;
    }

    input[type=date] {
        width: fit-content;
    }
}

.label-semana-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
}

.label-semana-wrapper h3 {
    margin: 0;
}

.btn-hoje {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.35rem 0.75rem;
    border: 1px solid var(--cor-separador, #e0e0e0);
    border-radius: 6px;
    background: var(--cor-bg, #fff);
    color: var(--cor-fonte, #555);
    font-size: 0.9rem;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
}

.btn-hoje:hover {
    background: var(--cor-cinza2, #f0f0f0);
    color: var(--cor-fonte-forte, #333);
}

.abas-nav {
    justify-content: center;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.btn-setas {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;
    padding: 0;
    border: 1px solid var(--cor-separador, #e0e0e0);
    border-radius: 6px;
    background: var(--cor-bg, #fff);
    color: var(--cor-fonte, #555);
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
}

.btn-setas:hover {
    background: var(--cor-cinza2, #f0f0f0);
    color: var(--cor-fonte-forte, #333);
}

.badge-hoje {
    display: inline-block;
    margin-right: 0.35em;
    padding: 0.15em 0.4em;
    border-radius: 4px;
    font-size: 0.75em;
    font-weight: 600;
    background: rgba(0, 0, 0, 0.15);
}

.ativo .badge-hoje {
    background: rgba(255, 255, 255, 0.35);
}

.badge-eventos {
    display: inline-block;
    min-width: 1.25em;
    margin-left: 0.35em;
    padding: 0.1em 0.35em;
    border-radius: 10px;
    font-size: .8rem;
    font-weight: 600;
    background: rgba(0, 0, 0, 0.12);
    line-height: 1.2;
}

.ativo .badge-eventos {
    background: rgba(255, 255, 255, 0.35);
}

.conectar-google,
.mensagem-reuniao-nao-agenda {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    margin-bottom: 1rem;
    background: #fef3c7;
    border: 1px solid #f59e0b;
    border-radius: 8px;
    color: #92400e;
}

.mensagem-reuniao-fechar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem;
    border: none;
    border-radius: 4px;
    background: transparent;
    color: #92400e;
    cursor: pointer;
    flex-shrink: 0;
}

.mensagem-reuniao-fechar:hover {
    background: rgba(146, 64, 14, 0.15);
}

.item-reuniao.reuniao-em-foco {
    box-shadow: 0 0 0 2px var(--cor-primaria, #0d6efd);
}

.linha-tarefa.tarefa-em-foco {
    background: rgba(13, 110, 253, 0.08);
}

.erro,
.sem-reunioes {
    padding: 1rem 0;
}

.mensagem-sucesso {
    color: green;
    margin-bottom: 1rem;
}

.conectar-google p,
.erro p {
    margin-bottom: 0.75rem;
}

.lista-reunioes {
    list-style: none;
    padding: 0;
    margin: 0;
}

.item-reuniao {
    padding: 1rem;
    margin-bottom: 1rem;
    border: 1px solid var(--cor-separador, #e0e0e0);
    border-radius: 8px;
    background: var(--cor-bg, #fff);
}

.item-reuniao.status-cancelado {
    opacity: 0.7;
    background: var(--cor-cinza, #fafafa);
}

.reuniao-cabecalho {
    justify-content: space-between;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.reuniao-titulo {
    font-weight: 600;
    font-size: 1.05rem;
}

.reuniao-horario,
.reuniao-info {
    font-size: 0.9rem;
    color: var(--cor-fonte-fraca, #555);
    margin: 0.35rem 0;
    display: flex;
    align-items: center;
    gap: 0.35rem;
}

.reuniao-descricao {
    font-size: 0.85rem;
    color: var(--cor-fonte-fraca, #666);
    margin: 0.5rem 0;
    line-height: 1.4;
}

.reuniao-descricao p {
    margin: 0.25em 0;
}

.reuniao-descricao p:first-child {
    margin-top: 0;
}

.reuniao-descricao p:last-child {
    margin-bottom: 0;
}

.reuniao-descricao b,
.reuniao-descricao strong {
    font-weight: 600;
}

.reuniao-tarefas {
    margin-top: 0.75rem;
    padding-top: 0.75rem;
}

.reuniao-participantes {
    margin-top: 0.75rem;
    padding-top: 0.75rem;
    border-top: 1px solid var(--cor-separador, #eee);
}

.anexos-google {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
}

.anexo-google {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    max-width: 100%;
    padding: 0.4rem 0.75rem;
    border: 1px solid var(--cor-separador, #e0e0e0);
    border-radius: 8px;
    background: var(--cor-cinza, #f8f9fa);
    color: var(--cor-fonte, #333);
    text-decoration: none;
    font-size: 0.85rem;
    font-weight: 500;
    transition: background 0.15s, border-color 0.15s;
}

.anexo-google:hover {
    background: var(--cor-primaria-fraca, #eef2ff);
    border-color: var(--cor-primaria-media, #c7d2fe);
    color: var(--cor-primaria-forte, #1e3a8a);
}

.anexo-google.tipo-gravacao i {
    color: #dc2626;
}

.anexo-google.tipo-transcricao i {
    color: #2563eb;
}

.anexo-google-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.participantes-titulo {
    font-size: 1rem;
    font-weight: 600;
    color: var(--cor-fonte-fraca, #666);
    margin-bottom: 0.4rem;
}

.participantes-lista {
    font-size: 0.9rem;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 16rem), 1fr));
    width: 100%;
    max-height: 12rem;
    overflow-y: auto;
    overflow-x: hidden;
}

.participante {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: .5rem;
    border-bottom: 1px solid var(--cor-separador);
    min-width: 0;

    .nome {
        font-weight: 500;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .chip {
        flex-shrink: 0;
    }
}

.reuniao-acoes {
    display: flex;
    gap: .5rem;

    a {
        font-size: .9rem;
    }
}

/* Evita que o CSS global [rel]:after exiba o valor de rel (ex.: "noopener") nos links */
/* .reuniao-acoes a[rel]::after {
    content: none !important;
} */


.ico-horario {
    font-size: 1rem;
}

.ico-local {
    content: "📍 ";
}
</style>
